 var uzcoll = document.getElementsByClassName("u-z-collapsibleuz");
   var uzi;
   for (uzi = 0; uzi < uzcoll.length; uzi++) {
    uzcoll[uzi].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
     if (content.style.maxHeight){
       content.style.maxHeight = null;
     } else {
       content.style.maxHeight = content.scrollHeight + "px";
         }
       });
     }
$('.M-trustpilot-slider').slick({
   infinite: true,
   slidesToShow: 2,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 3000,
     prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
  responsive: [
   {
      breakpoint: 900,
      settings: {
        arrows: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
   },
   {
      breakpoint: 600,
      settings: {
        arrows: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
   }
  ]
  });

 function updateTimer(id) {
    const timerElement = document.getElementById(id);
    if (!timerElement) return;
    let targetTime = localStorage.getItem("targetTime");
    if (!targetTime) {
      targetTime = new Date().getTime() + 10 * 60 * 1000;
      localStorage.setItem("targetTime", targetTime);
    }
    const interval = setInterval(() => {
      const currentTime = new Date().getTime();
      let timeRemaining = targetTime - currentTime;
      if (timeRemaining <= 0) {
        targetTime = new Date().getTime() + 10 * 60 * 1000;
        localStorage.setItem("targetTime", targetTime);
        timeRemaining = targetTime - currentTime;
      }
      const minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
      const seconds = Math.floor((timeRemaining / 1000) % 60);
      const formattedMinutes = minutes.toString().padStart(2, '0');
      const formattedSeconds = seconds.toString().padStart(2, '0');
      timerElement.textContent = `${formattedMinutes}:${formattedSeconds}`;
    }, 1000);
  }
  updateTimer();
